import ReactPaginate from 'react-paginate';

import type { PageInfoType } from '~/shared/types/general-type';

import './pagination.scss';

type PaginationPropsType = {
  marginPagesDisplayed: number;
  pageRangeDisplayed: number;
  previousLabel: string;
  nextLabel: string;
  breakLabel: string;
  breakClassName: string;
  containerClassName: string;
  subContainerClassName: string;
  activeClassName: string;
  pageInfo: PageInfoType;
  handlePageClick: (selection: { selected: number }) => void;
};

const Pagination = ({
  pageInfo,
  handlePageClick,
  previousLabel,
  nextLabel,
  breakLabel,
  breakClassName,
  marginPagesDisplayed,
  pageRangeDisplayed,
  containerClassName,
  subContainerClassName,
  activeClassName,
}: PaginationPropsType) => {
  const currentPage = pageInfo?.currentPage ?? 1;
  const pageCount = pageInfo?.pageCount ?? 1;

  return pageCount > 1 ? (
    <div className="pagination-block">
      <ReactPaginate
        previousLabel={previousLabel}
        nextLabel={nextLabel}
        breakLabel={breakLabel}
        breakClassName={breakClassName}
        forcePage={currentPage - 1}
        pageCount={pageCount}
        marginPagesDisplayed={marginPagesDisplayed}
        pageRangeDisplayed={pageRangeDisplayed}
        onPageChange={handlePageClick}
        containerClassName={containerClassName}
        subContainerClassName={subContainerClassName}
        activeClassName={activeClassName}
      />
    </div>
  ) : null;
};

export default Pagination;
